/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Architecture } from '../components/AncientArchitecture'
import HTMLParsedElement from './HTMLParsedElement'

export class ArchitectureElement extends HTMLParsedElement {
  parsedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)

    const text = this.textContent ?? "";
    try {
      const obj = JSON.parse(text);
      createRoot(mountPoint).render(<Architecture data={obj} styleRoot={mountPoint} />)
    } catch(err) {
      console.error(err, "Input JSON:", text, " in ", this)
    }
  }
}
customElements.define('ancient-architecture', ArchitectureElement)
